export const defaultPfp = require("@/assets/prezp_avatar.jpg");
